import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";

const AccessibilityMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const accessibilityOrders = getMetricGroupOrderIds(tab);

    const sortedAccessibilityMetrics = accessibilityOrders.map((order: number[]) => 
        categorizedData.Accessibility
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('accessibility data:', sortedAccessibilityMetrics)

    const accessibility: DisaggregatedMetric[] = sortedAccessibilityMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the indexMetric from metadata based on the current tab
    const indexMetricId = metadata?.find((metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === tab.toLowerCase())?.id || 0;

    // Find the full indicator object that matches indexMetric
    const indexMetricData = indicators.find(metric => metric.id === Number(indexMetricId)) || null;

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            <p className="text-lacey-text mx-4 text-[10px] mb-4">Data updates published April 17th, 2025.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {accessibility.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>
        </>
    );
}

export default AccessibilityMetrics;